<template>
  <div>
    <a-modal
      v-model="visibleModal"
      @cancel="handleCancel"
      :maskClosable="false"
      :title="
        mode === 'add'
          ? $t('library.ajouterDocument')
          : $t('library.editDocument')
      "
      :width="1000"
      :footer="null"
    >
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item :label="$t('library.titre')">
          <a-input
            v-decorator="[
              'title',
              { rules: [{ required: true, message: $t('requis.titre') }] },
            ]"
            :placeholder="$t('library.titre')"
          />
        </a-form-item>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item :label="$t('library.subject')">
              <a-select
                mode="multiple"
                :placeholder="`${$t('library.select')} ${$t(
                  'library.subject'
                )}`"
                v-decorator="[
                  'subject',
                  {
                    rules: [{ required: true, message: $t('requis.subject') }],
                  },
                ]"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="subject in listSubjects"
                  :key="subject._id"
                  :value="subject._id"
                >
                  {{ subject.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('etablissement.niveau')">
              <a-select
                mode="multiple"
                :placeholder="`${$t('library.select')} ${$t(
                  'etablissement.niveau'
                )}`"
                v-decorator="[
                  'level',
                  {
                    rules: [
                      { required: true, message: $t('library.levelRequired') },
                    ],
                  },
                ]"
                :filter-option="filterOption"
              >
                <a-select-option
                  v-for="(value, name, index) in levelSelectData"
                  :key="index"
                  :value="name"
                >
                  {{ value }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item
          :label="$t('actualite.description')"
          class="quill-editor-container"
        >
          <quill-editor v-model="description" :options="editorOptions" />
        </a-form-item>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item :label="$t('product.coverPicture')">
              <a-upload-dragger
                :file-list="coverPicture"
                :multiple="false"
                :custom-request="handleCustomRequest"
                :before-upload="beforeUploadCoverPicture"
                accept=".jpg,.jpeg,.png"
                list-type="picture"
                @change="handleChangeUploadCoverPicture"
                :auto-upload="false"
              >
                <p class="ant-upload-drag-icon">
                  <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text">
                  {{ $t("product.uploadCoverPicture") }}
                </p>
                <p class="ant-upload-hint">{{ $t("actualite.cliquer") }}</p>
              </a-upload-dragger>
              <a-progress
                v-if="coverPictureProgress.value > 0"
                :percent="coverPictureProgress.value"
                size="small"
                :stroke-color="{
                  from: '#108ee9',
                  to: '#87d068',
                }"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('library.attachment')">
              <a-upload-dragger
                :file-list="fileList"
                :before-upload="beforeUploadContent"
                :custom-request="handleCustomRequest"
                :multiple="true"
                @change="handleChangeUpload"
                :auto-upload="false"
              >
                <p class="ant-upload-drag-icon">
                  <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text">
                  {{ $t("library.uploadAttachment") }}
                </p>
                <p class="ant-upload-hint">
                  {{ $t("actualite.cliquer") }}
                </p>
              </a-upload-dragger>
              <span
                style="color: #f5222e; font-size: 14px"
                v-if="documentUploaded"
                >{{ $t("library.docRequired") }}</span
              >
              <a-progress
                v-if="filesProgress.value > 0"
                :percent="filesProgress.value"
                size="small"
                :stroke-color="{
                  from: '#108ee9',
                  to: '#87d068',
                }"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item>
          <a-button
            type="primary"
            htmlType="submit"
            class="mr-3"
            :loading="loading"
            :disabled="disabled"
            >{{
              mode === "add" ? $t("library.submit") : $t("action.modifier")
            }}</a-button
          >
          <a-button type="default" @click="handleCancel" :disabled="disabled">{{
            $t("action.annuler")
          }}</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import apiClient from "@/services/axios";
import { mapState } from "vuex";
import Quill from "quill";
import MagicUrl from "quill-magic-url";
import "quill/dist/quill.snow.css";
import { uploadFilesToS3 } from "@/services/uploadService";
import { getLevels } from "@/config/LevelConstants";

Quill.register("modules/magicUrl", MagicUrl);

export default {
  name: "AddDigitalLibrary",
  components: {
    quillEditor,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
    document: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState(["settings", "user"]),
    activeBuilding() {
      return this.user.building.find(
        (el) => el.dbName == this.settings.activeBuilding
      );
    },
    countryCode() {
      return this.activeBuilding?.countryCode;
    },
    levelSelectData() {
      return getLevels(this.$t.bind(this), this.schoolType, this.countryCode);
    },
  },
  data() {
    return {
      visibleModal: false,
      form: this.$form.createForm(this),
      documentData: {},
      description: "",
      listSubjects: [],
      fileList: [],
      files: [],
      coverPicture: [],
      deletefiles: [],
      documentUploaded: false,
      loading: false,
      disabled: false,
      schoolType: null,
      coverPictureProgress: { value: 0 },
      filesProgress: { value: 0 },
      editorOptions: {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            ["link"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
            ["clean"],
          ],
          magicUrl: true,
        },
      },
    };
  },
  watch: {
    visible(newVal) {
      this.visibleModal = newVal;
    },
    document: {
      immediate: true,
      handler(document) {
        if (document) {
          this.documentData = document;
          this.$nextTick(() => {
            this.form.setFieldsValue({
              title: document.title,
              subject: document.subject
                ? document.subject.map((item) => item._id)
                : [],
              level: document.level
                ? document.level.map((level) => String(level))
                : [],
            });
            this.description = document.description || "";
            if (document.coverPicture) {
              this.coverPicture = [
                {
                  uid: "-1",
                  name: this.getAttachmentName(document.coverPicture),
                  status: "done",
                  url: this.settings.resourcesUrl.replace(
                    "FILE_PATH",
                    document.coverPicture
                  ),
                  thumbUrl: this.settings.resourcesUrl.replace(
                    "FILE_PATH",
                    document.coverPicture
                  ),
                  originalPath: document.coverPicture, // Store the original file path from DB
                },
              ];
            }
            if (document.files && Array.isArray(document.files)) {
              this.fileList = document.files.map((attachmentUrl, index) => ({
                url: this.settings.resourcesUrl.replace(
                  "FILE_PATH",
                  attachmentUrl
                ),
                name: this.getAttachmentName(attachmentUrl),
                uid: index,
                status: "done",
                originalPath: attachmentUrl, // Store the original file path from DB
              }));
            }
          });
        }
      },
    },
  },
  created() {
    this.fetchOptions();
    this.schoolType = this.activeBuilding.type;
  },
  methods: {
    async fetchOptions() {
      try {
        const res = await apiClient.post("/subject/filter", {
          query: { status: "active" },
        });
        this.listSubjects = res.data.map((elem) => ({
          ...elem,
          key: elem._id,
        }));
      } catch (error) {
        this.$message.error(this.$t("error.aucMatiere"));
      }
    },
    getAttachmentName(url) {
      const parts = url.split("/");
      const fileNameWithType = parts[parts.length - 1];
      const decodedFileNameWithType = decodeURIComponent(fileNameWithType);
      const regex = /^\d+--(.+)$/;
      const match = decodedFileNameWithType.match(regex);
      const extractedName = match ? match[1] : decodedFileNameWithType;

      const lastDotIndex = extractedName.lastIndexOf(".");
      const fileName =
        lastDotIndex !== -1
          ? extractedName.slice(0, lastDotIndex)
          : extractedName;
      const fileType =
        lastDotIndex !== -1 ? extractedName.slice(lastDotIndex + 1) : "";

      return `${fileName}.${fileType}`;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    beforeUploadCoverPicture(file) {
      const isImage = ["image/jpeg", "image/png", "image/jpg"].includes(
        file.type
      );
      if (!isImage) {
        this.$message.error(this.$t("library.fileUploadError"));
        return false;
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error(this.$t("error.image"));
        return false;
      }
      this.coverPicture = [
        {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: URL.createObjectURL(file),
          thumbUrl: URL.createObjectURL(file),
          originFileObj: file,
        },
      ];
      return false;
    },
    beforeUploadContent(file, fileList) {
      // Allowed file types
      const allowedTypes = [
        // Images
        "image/jpeg",
        "image/jpg",
        "image/png",
        // PDF
        "application/pdf",
        // Office files
        "application/msword", // .doc
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
        "application/vnd.ms-excel", // .xls
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
        "application/vnd.ms-powerpoint", // .ppt
        "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
        // Video files
        "video/mp4",
        "video/webm",
      ];

      // Check file type
      const isValidType = allowedTypes.includes(file.type);
      if (!isValidType) {
        this.$message.error(this.$t("error.fileTypeNotAllowed"));
        return false;
      }

      // Check total files count
      const totalFiles = this.fileList.length + 1; // Count current file
      if (totalFiles > 15) {
        this.$message.error(this.$t("library.maxDocs"));
        return false;
      }

      let maxSize = 0;
      this.fileList.forEach((f) => {
        if (f.size) {
          maxSize += f.size;
        }
      });
      maxSize += file.size;
      maxSize = maxSize / 1024 / 1024;

      // Check total size (50MB)
      if (maxSize > 50) {
        this.$message.error(this.$t("error.image50"));
        return false;
      }

      // Only add the file if it passes all validation checks
      this.fileList = [...this.fileList, file];
      this.files = [...this.files, file];
      return true;
    },

    handleChangeUpload(info) {
      const { status } = info.file;
      this.documentUploaded = false;
      this.disabled = status === "uploading";
      if (status === "done") {
      }
      if (status === "removed") {
        this.fileList = this.fileList.filter(
          (item) => item.uid !== info.file.uid
        );
        this.files = this.files.filter((item) => item.uid !== info.file.uid);

        if (this.mode === "edit") {
          const removedIndex = this.documentData.files.findIndex(
            (item) => item === (info.file.originalPath || info.file.url)
          );
          if (removedIndex !== -1) {
            this.deletefiles.push(removedIndex);
          }
        }
      }
    },
    handleChangeUploadCoverPicture(info) {
      const { status } = info.file;
      if (status === "removed") {
        this.coverPicture = [];
      }
    },
    handleCustomRequest({ file, onSuccess }) {
      // Simulate uploading process
      setTimeout(() => {
        onSuccess("ok");
      }, 1000);
    },
    handleCancel() {
      this.form.resetFields();
      this.fileList = [];
      this.files = [];
      this.coverPicture = [];
      this.description = "";
      this.documentUploaded = false;
      this.visibleModal = false;
      this.documentData = {};
      this.deletefiles = [];
      this.$emit("close");
    },
    handleSubmit(e) {
      e.preventDefault();
      if (this.fileList.length === 0) {
        this.documentUploaded = true;
      }
      this.form.validateFields((err, values) => {
        if (!err && !this.documentUploaded) {
          if (this.mode === "add") {
            this.addDocument(values);
          } else {
            this.editDocument(values);
          }
        }
      });
    },
    addDocument(values) {
      this.loading = true;
      this.disabled = true;

      // Initialize progress trackers
      this.coverPictureProgress = { value: 0 };
      this.filesProgress = { value: 0 };

      const documentData = {
        title: values.title,
        subject: values.subject,
        level: values.level ? values.level.map((level) => Number(level)) : [],
      };

      if (this.description !== "") {
        documentData.description = this.description;
      }

      // Handle file uploads to S3 first
      const uploadPromises = [];
      const uploadResults = {
        coverPicture: null,
        files: [],
      };

      // Prepare cover picture upload if exists
      if (this.coverPicture.length > 0) {
        uploadPromises.push(
          uploadFilesToS3(
            [this.coverPicture[0].originFileObj],
            "library/coverPicture",
            this.coverPictureProgress
          ).then((keys) => {
            uploadResults.coverPicture = keys[0];
          })
        );
      }

      // Prepare document files upload
      if (this.fileList.length > 0) {
        const filesToUpload = this.fileList.map((file) =>
          file.originFileObj ? file.originFileObj : file
        );

        uploadPromises.push(
          uploadFilesToS3(
            filesToUpload,
            "library/documents",
            this.filesProgress
          ).then((keys) => {
            uploadResults.files = keys;
          })
        );
      }

      // Execute all uploads in parallel
      Promise.all(uploadPromises)
        .then(() => {
          // Add uploaded file paths to document data
          if (uploadResults.coverPicture) {
            documentData.coverPicture = uploadResults.coverPicture;
          }

          if (uploadResults.files.length > 0) {
            documentData.files = uploadResults.files;
          }

          return apiClient.put("library/item", documentData);
        })
        .then((res) => {
          this.$message.success(this.$t("success.libraryAddDoc"));
          this.$emit("documentAdded", res.data._id);
          this.handleCancel();
        })
        .catch((e) => {
          console.error("Error uploading files or saving document:", e);
          this.$message.error(this.$t("error.libraryAddDoc"));
        })
        .finally(() => {
          this.loading = false;
          this.disabled = false;
          this.coverPictureProgress = { value: 0 };
          this.filesProgress = { value: 0 };
        });
    },

    editDocument(values) {
      this.loading = true;
      this.disabled = true;

      // Initialize progress trackers
      this.coverPictureProgress = { value: 0 };
      this.filesProgress = { value: 0 };

      const documentData = {};

      // Only include changed fields
      if (values.title !== this.documentData.title) {
        documentData.title = values.title;
      }

      if (values.subject) {
        const existingSubjectIds = this.documentData.subject.map((subject) =>
          subject._id.toString()
        );
        const newSubjectIds = values.subject.map((subject) =>
          subject.toString()
        );
        if (
          JSON.stringify(newSubjectIds) !== JSON.stringify(existingSubjectIds)
        ) {
          documentData.subject = values.subject;
        }
      }

      if (values.level) {
        const documentLevelsAsStrings = this.documentData.level
          ? this.documentData.level.map((level) => String(level))
          : [];
        if (
          values.level.length !== documentLevelsAsStrings.length ||
          !values.level.every(
            (value, index) => value === documentLevelsAsStrings[index]
          )
        ) {
          documentData.level = values.level.map((level) => Number(level));
        }
      }

      if (this.description !== this.documentData.description) {
        documentData.description = this.description;
      }

      // Handle cover picture - set to null if removed, or preserve existing if not changed
      if (this.coverPicture.length === 0) {
        documentData.coverPicture = null;
      } else if (
        this.coverPicture.length > 0 &&
        !this.coverPicture[0].originFileObj
      ) {
        // Preserve existing cover picture if not changed
        documentData.coverPicture = this.coverPicture[0].originalPath;
      }

      // Check if files have been modified (added or removed)
      const originalFileCount = this.documentData.files
        ? this.documentData.files.length
        : 0;
      const currentFileCount = this.fileList.length;
      const filesChanged = originalFileCount !== currentFileCount;

      // If files were removed but no new files added, we need to include the current file list
      if (filesChanged && !this.fileList.some((file) => file instanceof File)) {
        documentData.files = this.fileList.map(
          (file) => file.originalPath || file.url
        );
      }

      // Handle file uploads to S3 first
      const uploadPromises = [];

      // Prepare cover picture upload if it's new
      if (this.coverPicture.length > 0 && this.coverPicture[0].originFileObj) {
        uploadPromises.push(
          uploadFilesToS3(
            [this.coverPicture[0].originFileObj],
            "library/coverPicture",
            this.coverPictureProgress
          ).then((keys) => {
            documentData.coverPicture = keys[0];
          })
        );
      }

      // Prepare new document files upload
      const newFiles = this.fileList.filter((file) => file instanceof File);
      if (newFiles.length > 0) {
        const filesToUpload = newFiles;

        uploadPromises.push(
          uploadFilesToS3(
            filesToUpload,
            "library/documents",
            this.filesProgress
          ).then((keys) => {
            // Combine existing files (that weren't deleted) with new files
            const existingFiles = this.fileList
              .filter((file) => file.url && !(file instanceof File))
              .map((file) => file.originalPath || file.url);

            documentData.files = [...existingFiles, ...keys];
          })
        );
      }

      const id = this.documentData._id;

      // Execute all uploads in parallel, then update the document
      Promise.all(uploadPromises)
        .then(() => {
          return apiClient.patch(`library/item/${id}`, documentData);
        })
        .then((res) => {
          this.$message.success(this.$t("success.libraryUpdateDoc"));
          this.$emit("documentUpdated", id);
          this.handleCancel();
        })
        .catch((e) => {
          console.error("Error updating document:", e);
          this.$message.error(this.$t("error.libraryUpdateDoc"));
        })
        .finally(() => {
          this.loading = false;
          this.disabled = false;
          this.coverPictureProgress = { value: 0 };
          this.filesProgress = { value: 0 };
        });
    },
  },
};
</script>

<style>
.switch-container {
  display: flex;
  align-items: center;
}

.switch-container p {
  margin-left: 10px;
  margin-bottom: 0;
}

.ql-snow .ql-tooltip {
  z-index: 3 !important;
}
</style>
